import { OkIcon, ExpiredIcon } from "../CourseStatusIcon";

const TrainingModuleStatus = ({ status }) => {
  return <>{status === 1 ? <OkIcon /> : <ExpiredIcon />}</>;
};

export default TrainingModuleStatus;
